module.exports = __webpack_public_path__ + "img/full5-min.ef79050f.png";